
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/create/[company]",
      function () {
        return require("private-next-pages/account/create/[company].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/create/[company]"])
      });
    }
  